import moment from "moment";

const TITLE = "คุณ";

function joinName(parts) {
  return parts.filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
}

export default function buildWelcomePayload(appointment, ctx = {}) {
  const ext = (appointment && appointment.extendedProps) || {};
  const patient = ext.patient || {};
  const { branchInfo = {}, roomList = [], viewFile, now = moment() } = ctx;

  const fullNameTh =
    joinName([TITLE + (patient.firstNameTh || ""), patient.lastNameTh]) ||
    ext.patientName ||
    "";
  const fullNameEn = joinName([patient.firstNameEn, patient.lastNameEn]) || null;
  const nickname = (patient.nickName || "").trim() || null;

  const age = patient.dob
    ? moment(now).diff(moment(patient.dob, "YYYY-MM-DD"), "years")
    : null;

  const room = roomList.find((r) => String(r.id) === String(ext.roomId));
  const roomName = room ? room.name : null;

  const clinic = branchInfo.clinic || {};
  const clinicLogoUrl =
    clinic.logo && typeof viewFile === "function" ? viewFile(clinic.logo) : null;

  const durationMinutes =
    Number.isFinite(ext.timeDuration) && ext.timeDuration > 0
      ? ext.timeDuration
      : null;

  return {
    appointmentId: ext.id || (appointment && appointment.id) || null,
    fullNameTh,
    fullNameEn,
    nickname,
    age,
    treatmentTitle: ext.treatmentTitle || null,
    doctorName: (ext.doctorName || "").trim() || null,
    durationMinutes,
    roomName,
    dateText: moment(now).locale("th").format("D MMM YYYY"),
    clinicName: clinic.name || "",
    clinicNameEn: clinic.nameEn || null,
    clinicLogoUrl,
    clinicPhone: (branchInfo.tel || "").trim(),
    allergies: (patient.allergic || "").trim(),
    conditions: (patient.congenitalDisease || "").trim(),
  };
}
